@if (showIfNone || todoCount > 0) {
  <div class="card-notification-counter counter-{{ todoCount }}">
    <div matBadge="{{ primaryCount }}" class="primary-badge">
      <div matBadge="{{ secondaryCount }}" class="secondary-badge">
        <a [routerLink]="linkTarget"
          [class.mat-elevation-z1]="todoCount === 0"
          [class.mat-elevation-z3]="todoCount > 0"
          matRipple
          >
          <mat-icon>{{ icon }}</mat-icon>
          <span class="counter-label">{{ label }}</span>
        </a>
      </div>
    </div>
  </div>
}
